module.exports = __webpack_public_path__ + "img/normal.8f2a7aaa.svg";